import FlexCenter from './FlexCenter'

export default FlexCenter
